import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTime } from '@mode-switch/express';
import { IconComponent } from '@mode/capra';
import { GoogleAccountFacade, WorkspaceSettingsDomainModule } from '@mode/workspace-settings/domain';
import { MetaTags, MetaTagsService, LocalStorageService } from '@mode/shared/util-js';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-google-account-admin',
  standalone: true,
  imports: [CommonModule, IconComponent, WorkspaceSettingsDomainModule],
  templateUrl: './google-account-admin.component.html',
  styleUrls: ['./google-account-admin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleAccountAdminComponent {
  @Input() email?: string;
  @Input() connectedBy?: string;
  @Input() lastUploadedAt?: string;

  constructor(
    private analyticsService: AnalyticsService,
    private meta: MetaTagsService,
    private localStorageService: LocalStorageService
  ) {}
}
